import React from "react";
import "./ExaminationRestrictionsDialog.css";
import { Alert, Form, FormControl, InputGroup } from "react-bootstrap";
import Switch from "react-switch";
import CamplaCoreService from "../../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import MultiSelectTextInput from "../../../../../components/multiselectTextInput/MultiSelectTextInput";
import equals from "fast-deep-equal";
import BaseDialog from "../../../../../components/dialogs/baseDialog/BaseDialog";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseDatePicker from "../../../../../components/baseDatePicker/BaseDatePicker";

class ExaminationRestrictionsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = this.getValidationDefinitionFromRestrictions(
        this.props.restrictions
    );

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      commonFileTypes: [
        { label: "pdf", value: "pdf", isFixed: false },
        { label: "zip", value: "zip", isFixed: false },
        { label: "docx", value: "docx", isFixed: false },
        { label: "xlsx", value: "xlsx", isFixed: false },
        { label: "pptx", value: "xlsx", isFixed: false },
      ],
      limitations: {
        maxNumberFiles: undefined,
        maxTotalSize: undefined
      }
    };

    this.onlyPDFAllowed = this.props.examination.instanceTemplate.type === 2 || (
        this.props.examination.instanceTemplate.type === 1 && (
            this.props.examination.securityLevel === 5 || this.props.examination.securityLevel === 6)
    );

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }



  getValidationDefinitionFromRestrictions(restrictions) {
    return {
      allowStudentFiles: {
        defaultValue: restrictions.allowStudentFiles,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },

      allowedFileTypes: {
        defaultValue: this.onlyPDFAllowed ? ["pdf"] : restrictions.allowedFileTypes,
        initValid: true,
        rule: Array.isArray
      },
      maxNumberFiles: {
        defaultValue: restrictions.maxNumberFiles,
        initValid: true,
        rule: value =>
            ValidationHelper.isIntInRange(
                value,
                this.getMinNumberFiles(),
                this.getMaxNumberFiles()
            )
      },
      maxTotalSize: {
        defaultValue: Math.floor(restrictions.maxTotalSize / (1024 * 1024)),
        initValid: true,
        rule: value =>
            ValidationHelper.isIntInRange(
                value,
                this.getMinTotalSize(),
                this.getMaxTotalSize()
            )
      },
      submissionEndDate: {
        defaultValue: restrictions.submissionEndDate ? new Date(Date.parse(restrictions.submissionEndDate)) : null,
        initValid: true,
        rule: value => (ValidationHelper.isFutureDate(value) && Date.parse(value) < Date.parse(this.props.examination.start)) || value === null
      },
      autoAcceptAfterEndDate: {
        defaultValue: restrictions.autoAcceptAfterEndDate,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      enableSubmissionEndDate: {
        defaultValue: restrictions.submissionEndDate !== null,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
    };
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (
        !equals(prevProps.restrictions, this.props.restrictions) ||
        (this.props.show && prevProps.show !== this.props.show)
    ) {
      this.setState({
        validation: ValidationHelper.getValidation(
            this.getValidationDefinitionFromRestrictions(this.props.restrictions)
        )
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      if (
          !validatedData.allowStudentFiles &&
          !this.props.restrictions.allowStudentFiles
      ) {
        this.props.onHide(false);
      } else {
        this.props.onSubmit(validatedData);
      }
    }
  }

  getMinTotalSize() {
    if (this.props.hasFiles) {
      return Math.floor(this.props.restrictions.maxTotalSize / (1024 * 1024));
    }
    return 1;
  }

  getMaxTotalSize() {
    return (
        Math.floor(this.props.defaultRestrictions.limitation.maxTotalSize / (1024 * 1024))
    );
  }

  getMinNumberFiles() {
    if (this.props.hasFiles) {
      return this.props.restrictions.maxNumberFiles;
    }
    return 1;
  }

  getMaxNumberFiles() {
    return this.props.defaultRestrictions.limitation.maxNumberFiles;
  }

  render() {
    const { t } = this.props;
    const fixedOptions = this.props.hasFiles
        ? this.props.restrictions.allowedFileTypes.map(f => ({ label: f, value: f }))
        : [];
    return (
        <BaseDialog
            show={this.props.show}
            onHide={this.onHide}
            title={t(
                "SingleExamination.StudentFileProposalsTab.RestrictionsModal.RestrictionModalTitle"
            )}
            dialogApiError={this.props.dialogApiError}
            rightButtonCallback={this.onSubmit}
            rightButtonText={t("ModuleClasses.ModuleClassModal.Form.Submit")}
            rightButtonVariant={"green"}
            leftButtonVariant={"black"}
            leftButtonText={t("DialogCancel")}
            leftButtonCallback={this.onHide}
            rightButtonDisabled={!this.state.validation._isValid}
            body={(<Form onSubmit={this.onSubmit}>
              <Form.Group controlId="formBasicAllowStudentFiles">
                <Form.Label>
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AllowedStudentFiles"
                  )}{" "}
                </Form.Label>
                <Switch
                    className="float-right"
                    onColor="#54BF8D"
                    disabled={
                      this.props.hasFiles &&
                      this.props.restrictions.allowStudentFiles
                    }
                    checked={this.state.validation.allowStudentFiles.value}
                    onChange={(state) => {
                      this.handleChange({
                        target: {
                          name: "allowStudentFiles",
                          value: state
                        }
                      });
                    }}
                    height={18}
                    width={40}
                />
                <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.allowStudentFiles.isValid}
                />
              </Form.Group>
              <Alert variant="warning">
                {t(
                    "SingleExamination.StudentFileProposalsTab.RestrictionsModal.WarningText"
                )}
              </Alert>
              <hr />
              <Form.Group controlId="formBasicSubmissionEndDate">
                <Form.Label>
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.EnableSubmissionEndDate"
                  )}{" "}
                </Form.Label>
                <Switch
                    className="float-right"
                    onColor="#54BF8D"
                    checked={this.state.validation.enableSubmissionEndDate.value}
                    disabled={!this.state.validation.allowStudentFiles.value}
                    onChange={(state) => {
                      this.handleChange({
                        target: {
                          name: "enableSubmissionEndDate",
                          value: state
                        }
                      });
                      if (!state){
                        this.handleChange({
                          target: {
                            name: "submissionEndDate",
                            value: null
                          }
                        });
                        this.handleChange({
                          target: {
                            name: "autoAcceptAfterEndDate",
                            value: false
                          }
                        });
                      }
                    }}
                    height={18}
                    width={40}
                />
                <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.enableSubmissionEndDate.isValid}
                />
              </Form.Group>
              {this.state.validation.enableSubmissionEndDate.value && this.state.validation.allowStudentFiles.value ? (<>
                <Form.Group controlId="formSubmissionEndDate">
                  <Form.Label>
                    {t("SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.SubmissionEndDate")}
                  </Form.Label>
                  <div>
                    <BaseDatePicker
                        name="submissionEndDate"
                        className="form-control"
                        onChange={(d) => {
                          this.handleChange({
                            target: {
                              name: "submissionEndDate",
                              value: d
                            },
                          });
                        }}
                        value={this.state.validation.submissionEndDate.value}
                        min={new Date()}
                    />
                  </div>
                  <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.submissionEndDate.isValid}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t(
                        "SingleExamination.StudentFileProposalsTab.RestrictionsModal.ValidationError.SubmissionEndDate"
                    )}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formBasicAutoAcceptAfterEndDate">
                  <div className="custom-checkbox">
                    <Form.Check
                        custom
                        type="checkbox"
                        label={t(
                            "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AutoAcceptAfterEndDate"
                        )}
                        checked={this.state.validation.autoAcceptAfterEndDate.value}
                        onChange={(state) => {
                          this.handleChange({
                            target: {
                              name: "autoAcceptAfterEndDate",
                              value: !this.state.validation.autoAcceptAfterEndDate.value
                            },
                          });
                        }}
                    />
                  </div>
                </Form.Group>
                <hr />
              </>) : ""}
              {this.props.examination.instanceTemplate.type !== 2 ? (<Form.Group controlId="formBasicAllowedFileTypes">
                <Form.Label>
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AllowedFileTypes"
                  )}
                </Form.Label>
                <MultiSelectTextInput
                    handleChange={value =>
                        this.handleChange({
                          target: { name: "allowedFileTypes", value }
                        })
                    }
                    disabled={!this.state.validation.allowStudentFiles.value || this.onlyPDFAllowed}
                    values={this.state.validation.allowedFileTypes.value}
                    placeholder={t(
                        "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AllowedFileTypesPlaceholder"
                    )}
                    showMenu={true}
                    fixedOptions={fixedOptions}
                    options={this.state.commonFileTypes}
                />
                {this.state.validation.allowedFileTypes.value.length < 1 ? (
                    <Form.Text className="color-yellow">
                      <FontAwesomeIcon icon={faExclamationTriangle} /> {t(
                        "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AllowedFileTypesDescription"
                    )}
                    </Form.Text>
                ) : (
                    ""
                )}
                <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.allowedFileTypes.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t("ModuleClasses.ModuleClassModal.ValidationError.ClassId")}
                </Form.Control.Feedback>
              </Form.Group>) : (
                  <Alert variant="info">
                    <b>{t(
                        "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.AllowedFileTypes"
                    )}</b>: PDF
                  </Alert>
              )}
              <Form.Group controlId="formBasicNumFiles">
                <Form.Label>
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.MaxNumberFiles"
                  )}
                </Form.Label>
                <InputGroup>
                  <FormControl
                      type="number"
                      min={this.getMinNumberFiles()}
                      max={this.getMaxNumberFiles()}
                      disabled={!this.state.validation.allowStudentFiles.value}
                      value={this.state.validation.maxNumberFiles.value}
                      isInvalid={!this.state.validation.maxNumberFiles.isValid}
                      onChange={event =>
                          this.handleChange({
                            target: {
                              name: "maxNumberFiles",
                              value: parseInt(event.target.value)
                            }
                          })
                      }
                      onBlur={event => {
                        this.handleChange({
                          target: {
                            name: "maxNumberFiles",
                            value: parseInt(event.target.value)
                          }
                        });
                      }}
                  />
                  <InputGroup.Append>
                    <InputGroup.Text id="inputGroupAppend">
                      {t(
                          "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.Files"
                      )}
                    </InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
                <Form.Text
                    disabled={!this.state.validation.allowStudentFiles.value}
                >
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.MaxNumberFilesLimit",
                      {
                        min: this.getMinNumberFiles(),
                        max: this.getMaxNumberFiles()
                      }
                  )}
                </Form.Text>
                <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.maxNumberFiles.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.ValidationError.MaxNumberFiles",
                      {
                        min: this.getMinNumberFiles(),
                        max: this.getMaxNumberFiles()
                      }
                  )}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formBasicMaxTotalSize">
                <Form.Label>
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.MaxTotalSize"
                  )}
                </Form.Label>
                <InputGroup>
                  <FormControl
                      type="number"
                      min={this.getMinTotalSize()}
                      max={this.getMaxTotalSize()}
                      disabled={!this.state.validation.allowStudentFiles.value}
                      value={this.state.validation.maxTotalSize.value}
                      isInvalid={!this.state.validation.maxTotalSize.isValid}
                      onChange={event =>
                          this.handleChange({
                            target: {
                              name: "maxTotalSize",
                              value: parseInt(event.target.value)
                            }
                          })
                      }
                      onBlur={event => {
                        this.handleChange({
                          target: {
                            name: "maxTotalSize",
                            value: parseInt(event.target.value)
                          }
                        });
                      }}
                  />
                  <InputGroup.Append>
                    <InputGroup.Text id="inputGroupAppend">
                      {t(
                          "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.Megabytes"
                      )}
                    </InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
                <Form.Text
                    disabled={!this.state.validation.allowStudentFiles.value}
                >
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.Form.MaxTotalSizeLimit",
                      { min: this.getMinTotalSize(), max: this.getMaxTotalSize() }
                  )}
                </Form.Text>
                <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.maxTotalSize.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t(
                      "SingleExamination.StudentFileProposalsTab.RestrictionsModal.ValidationError.MaxTotalSize",
                      { min: this.getMinTotalSize(), max: this.getMaxTotalSize() }
                  )}
                </Form.Control.Feedback>
              </Form.Group>
            </Form>)}
        />
    );
  }
}

export default withTranslation()(ExaminationRestrictionsDialog);
